import { render } from "./DatasetCreateModal.vue?vue&type=template&id=fb25ce5e&scoped=true"
import script from "./DatasetCreateModal.vue?vue&type=script&lang=js"
export * from "./DatasetCreateModal.vue?vue&type=script&lang=js"

import "./DatasetCreateModal.vue?vue&type=style&index=0&id=fb25ce5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb25ce5e"]])

export default __exports__